'use strict';

module Patersons {

    export class AnalysisService extends BaseService{

        getWatchlists() {
            return this.get("/dataService/odata/watchlists");
        };

        getAWatchlist(watchlistId: number){
            return this.get("/dataService/odata/watchlists(" + watchlistId + ")");
        };

        patchWatchlist(watchlist: Watchlist) {
            return this.patch("/dataService/odata/watchlists(" + watchlist.id + ')', watchlist);
        };

        postWatchlist(newWatchlist: Watchlist) {
            return this.post("/dataService/odata/watchlists", newWatchlist);
        };

        deleteWatchlist(watchlistId: number) {
            return this.delete("/dataService/odata/watchlists(" + watchlistId + ")");
        };
    }
}